import React from 'react';
import { RenderFieldDetails } from '../create-proposal/components/selected-properties-render-field-details';
import Slider from 'react-slick';
import moment from 'moment';
import { convertPascalCaseToWords } from '../../core';
import { Project, PropertyDetails, Unit } from '../../core/api/models/project';
import { LeadRequirement } from '../../core/api/models/requirement';

interface SearchPropertiesDropdownTableProps {
    dropdownClick: (event: any, id: string, fieldName: string) => void;
    dropPos: { open: boolean; x: string; y: string; id: string; fieldName: string; } | undefined;
    floors: any[];
    item: Project;
    onAllSelected: (selected: boolean, project: Project) => void;
    onSelect: (ut: Unit, sel: boolean, project: Project) => void;
    ordinalSuffixOf: (i: number) => string;
    properties: any;
    selectedProperty: PropertyDetails[] | undefined;
    setPropertyDetailModal: React.Dispatch<React.SetStateAction<{ isOpen?: boolean; propertyId?: string }>>;
    statusItem: any;
    unitDetails: any;
    sortList?: any[];
    configuration: LeadRequirement;
}

const settings = {
    className: "require-slider slick-slider-p",
    dots: false,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: true,
    autoplay: false,
    responsive: [
        {
            breakpoint: 980, // tablet breakpoint
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // mobile breakpoint
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export function SearchPropertiesDropdownTable({ dropdownClick,
    dropPos,
    floors,
    item,
    onAllSelected,
    onSelect,
    ordinalSuffixOf,
    properties,
    selectedProperty,
    setPropertyDetailModal,
    statusItem,
    unitDetails,
    sortList,
    configuration
}: SearchPropertiesDropdownTableProps) {
    return (
        <>
            <div
                className="py-4 pr-4 pl-5"
                style={{ maxWidth: "90vw" }}
            >
                <Slider {...settings}>
                    <div className="border rounded px-2 py-15 d-inline-block mr-1 w-auto">
                        <div className="font-xs font-weight-semibold title d-flex align-items-end">
                            Matching Unit{" "}
                            {!!selectedProperty?.filter(
                                (ff) => ff.projectId === item._id
                            )?.length && (
                                    <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                        {
                                            selectedProperty?.filter(
                                                (ff) => ff.projectId === item._id
                                            )?.length
                                        }
                                    </span>
                                )}
                        </div>
                        <div className="font-xs font-weight-medium text-gray-700">
                            {
                                unitDetails?.filter((x: any) =>
                                    item.properties?.find(
                                        (p) =>
                                            p.propertyID?.toString() ===
                                            x.propertyID?.toString() &&
                                            p.propertyAvailableStatus ===
                                            "available"
                                    )
                                )?.length
                            }{" "}
                            Available, {unitDetails?.length} Total
                        </div>
                    </div>
                    {floors?.map((fl) => {
                        const availableCount = unitDetails?.filter(
                            (x: any) =>
                                item.properties?.find(
                                    (p) =>
                                        p.propertyID?.toString() ===
                                        x.propertyID?.toString() &&
                                        p.propertyAvailableStatus === "available"
                                ) && x.floorName === fl
                        )?.length;
                        const totalCount = unitDetails?.filter(
                            (x: any) => x.floorName === fl
                        )?.length;

                        return (
                            <>
                                <div className="border rounded px-2 py-15 d-inline-block mr-1 w-auto">
                                    {fl === 0 ? (
                                        <div className="font-xs font-weight-semibold title d-flex align-items-end">
                                            Ground Floor
                                            {!!selectedProperty?.filter(
                                                (ff) =>
                                                    ff.projectId === item._id &&
                                                    ff.floor === fl
                                            )?.length && (
                                                    <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                                        {
                                                            selectedProperty?.filter(
                                                                (ff) =>
                                                                    ff.projectId === item._id &&
                                                                    ff.floor === fl
                                                            )?.length
                                                        }
                                                    </span>
                                                )}
                                        </div>
                                    ) : (
                                        <div className="font-xs font-weight-semibold title d-flex align-items-end">
                                            {ordinalSuffixOf(Number(fl))} Floor
                                            {!!selectedProperty?.filter(
                                                (ff) =>
                                                    ff.projectId === item._id &&
                                                    ff.floor === fl
                                            )?.length && (
                                                    <span className="count-filter mx-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center ml-1">
                                                        {
                                                            selectedProperty?.filter(
                                                                (ff) =>
                                                                    ff.projectId === item._id &&
                                                                    ff.floor === fl
                                                            )?.length
                                                        }
                                                    </span>
                                                )}
                                        </div>
                                    )}
                                    <div className="font-xs font-weight-medium text-gray-700">
                                        {availableCount} Available, {totalCount}{" "}
                                        Total
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </Slider>
            </div>
            <div>
                <table className="table table-bordered w-100 font-sm">
                    <tr>
                        <td
                            className="py-2  px-2   border-bottom px-1"
                            style={{ maxWidth: "40px", width: "40px" }}
                        >
                            <div className="">
                                <input
                                    type="checkbox"
                                    name={`propertyCheck-unit-${item.projectID}`}
                                    id={`propertyCheck- px-2 -${item.projectID}`}
                                    onChange={(e) =>
                                        onAllSelected(e.target.checked, item)
                                    }
                                    checked={
                                        selectedProperty?.filter(
                                            (ff) => ff.projectId === item._id
                                        )?.length === unitDetails?.length &&
                                        !!unitDetails?.length
                                    }
                                />
                                <label
                                    htmlFor={`propertyCheck- px-2 -${item.projectID}`}
                                ></label>
                            </div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Floor</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Unit Id</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Area (in Sq.Ft)</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Interior Type</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Quoted Rent</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Current Status</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Available From</div>
                        </td>
                        <td className="py-2 border-bottom font-sm">
                            <div className="py-1">Contact Details</div>
                        </td>
                    </tr>
                    {properties?.map((property: any) => {
                        const unit = unitDetails?.find(
                            (p: any) =>
                                p.propertyID?.toString() ===
                                property.propertyID?.toString()
                        );

                        const isShorted = !!sortList?.find(
                            (x) =>
                                x.propertyDetailsFromProject?.unitId?.toString() ===
                                unit?.unitID?.toString()
                        );
                        return (
                            <>
                                <tr
                                    role="button"
                                    onClick={() => {
                                        if (property?.propertyAvailableStatus === "available") {
                                            setPropertyDetailModal({
                                                isOpen: true,
                                                propertyId: property._id,
                                            })
                                        }
                                    }}
                                >
                                    <td
                                        className="py-3 px-2 border-bottom px-0"
                                        style={{
                                            maxWidth: "40px",
                                            width: "40px",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="">
                                            <input
                                                type="checkbox"
                                                name={`propertyCheck-${unit?.unitID}-${item.projectID}`}
                                                id={`propertyCheck-${unit?.unitID}-${item.projectID}`}
                                                onChange={(e) =>
                                                    onSelect(
                                                        unit!,
                                                        e.target.checked,
                                                        item
                                                    )
                                                }
                                                checked={
                                                    !!selectedProperty?.find(
                                                        (fv) => fv.unitId === unit?.unitID
                                                    )
                                                }
                                            />
                                            <label
                                                htmlFor={`propertyCheck-${unit?.unitID}-${item.projectID}`}
                                            ></label>
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">{unit?.floorName}</div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">{unit?.unitName}</div>
                                        {isShorted && (
                                            <span className="tag--active font-xxs">
                                                Short Listed
                                            </span>
                                        )}
                                        {statusItem &&
                                            statusItem.length > 0 &&
                                            statusItem[0].proposalStatus !==
                                            undefined && (
                                                <>
                                                    <span className="tag--pending font-xxs spaced-span m-2">
                                                        {statusItem && statusItem.length
                                                            ? "Proposal" +
                                                            " " +
                                                            statusItem[0].proposalStatus
                                                            : ""}
                                                    </span>
                                                </>
                                            )}
                                        {moment(property?.availablefromdate).isAfter(moment()) && configuration?.includeLeaseExpiry && (
                                            <span className="tag--leaseexpired font-xxs">
                                                Option due to lease expiry
                                            </span>
                                        )}
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">{unit?.unitArea}</div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {property?.attribute?.interiorType}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {
                                                property?.attribute
                                                    ?.quotedRentPerSqFtPerMonth
                                            }{" "}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        <div className="">
                                            {convertPascalCaseToWords(
                                                property?.propertyAvailableStatus
                                            )}
                                        </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                        {property?.availablefromdate &&
                                            property?.availablefromdate !==
                                            "1970-01-01T00:00:00.000Z" && (
                                                <div className="">
                                                    {moment(
                                                        property?.availablefromdate
                                                    ).format("DD-MM-YYYY")}
                                                </div>
                                            )}
                                    </td>
                                    <td
                                        className="py-2 border-bottom"
                                        style={{ width: "290px", maxWidth: "290px" }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div role="button" className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                            onClick={(e) => dropdownClick(e, property?._id, 'ContactDetails')}
                                        >
                                            {property?.contactDetails?.length
                                                ? property?.contactDetails?.length > 2
                                                    ? property.contactDetails
                                                        .slice(0, 2)
                                                        .map((participant: any) =>
                                                            participant
                                                                ? `${participant.contactName || ''}`
                                                                : ''
                                                        )
                                                        .join(", ")
                                                    : property?.contactDetails?.map((participant: any) =>
                                                        participant
                                                            ? `${participant.contactName || ''}`
                                                            : ''
                                                    )
                                                        .join(", ")
                                                : ""}
                                            <span
                                                className="text-primary cursor-pointer"

                                            >
                                                {property?.contactDetails?.length > 2 ? ` +${property?.contactDetails?.length - 2}` : ''}
                                                {property._id === dropPos?.id && dropPos?.fieldName === 'ContactDetails' &&
                                                    dropPos?.open && <RenderFieldDetails fieldName="Contact Details" fieldArrayValues={property?.contactDetails} />}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        );
                    })}
                </table>
            </div>
        </>

    );
}
